/**
 * JS pro zobrazení obrazku v bs modalu.
 * Je třeba k elementu pterý má modal otevřít přidat data-show-picture-in-modal='true'"
 * Do data atributu data-image dát path k obrázku, který se má do modalu načíst.
 */

export default function () {
	let showPictureLinks = document.querySelectorAll('[data-show-picture-in-modal]');
	if (showPictureLinks.length === 0) {
		return false;
	}

	// Funkce pro vytvoření HTML modalu
	function createModalHtml() {
		const modal = document.createElement('div');
		modal.className = 'modal fade';
		modal.id = 'imageModal';
		modal.tabIndex = -1;
		modal.setAttribute('aria-labelledby', 'imageModalLabel');
		modal.setAttribute('aria-hidden', 'true');

		const modalDialog = document.createElement('div');
		modalDialog.className = 'modal-dialog modal-dialog-centered modal-lg';

		const modalContent = document.createElement('div');
		modalContent.className = 'modal-content';
		modalContent.style.overflow = 'hidden';
		modalContent.style.display = 'flex';
		modalContent.style.flexDirection = 'column';
		modalContent.style.maxHeight = '90vh';

		const modalBody = document.createElement('div');
		modalBody.className = 'modal-body text-center px-0';
		modalBody.style.overflowY = 'auto';
		modalBody.style.flexGrow = '1';
		modalBody.style.minHeight = '0';

		const closeButton = document.createElement('button');
		closeButton.type = 'button';
		closeButton.className = 'btn-close';
		closeButton.setAttribute('data-bs-dismiss', 'modal');
		closeButton.setAttribute('aria-label', 'Zavřít');

		const modalImage = document.createElement('img');
		modalImage.id = 'modalImage';
		modalImage.src = '';
		modalImage.alt = 'Zobrazený obrázek';
		modalImage.className = 'img-fluid';
		modalImage.style.maxHeight = '100%';
		modalImage.style.width = 'auto';

		modalBody.appendChild(closeButton);
		modalBody.appendChild(modalImage);
		modalContent.appendChild(modalBody);
		modalDialog.appendChild(modalContent);
		modal.appendChild(modalDialog);

		document.body.appendChild(modal);
	}

	if (!document.getElementById('imageModal')) {
		createModalHtml();
	}

	// Inicializace modalu
	const modalElement = document.getElementById('imageModal');
	const modal = new window.Modal(modalElement);
	const modalImage = document.getElementById('modalImage');

	showPictureLinks.forEach(link => {
		const isEnabled = link.getAttribute('data-show-picture-in-modal') === 'true'; // Kontrola hodnoty atributu
		if (!isEnabled) {
			return;
		}
		link.addEventListener('click', function (e) {
			e.preventDefault();
			const imageSrc = this.getAttribute('data-image');
			if (imageSrc) {
				modalImage.src = imageSrc;
				modal.show();
			}
		});
	});
}
